import { render } from "./EdProfile.vue?vue&type=template&id=14cc6b35"
import script from "./EdProfile.vue?vue&type=script&lang=js"
export * from "./EdProfile.vue?vue&type=script&lang=js"

import "./EdProfile.vue?vue&type=style&index=0&id=14cc6b35&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__